import { ITxTransport } from "lib/deviceDrivers/sessionFramework/device/types";

/**
 * Puts one command payload on the wire without waiting for the send to settle.
 * All outgoing sends go through here so protocol-level wrapping (e.g. CRC) can be added in one place.
 */
export function sendCommand(tx: ITxTransport, payload: string): void {
  tx.send(payload).catch((error: unknown) => {
    // eslint-disable-next-line no-console
    console.error("sendCommand: unexpected transport send failure", error);
  });
}
